import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { sanitize } from 'dompurify';
import Head from '../../hocs/Head/Head';
import ErrorBoundary from '../../hocs/ErrorBoundary/ErrorBoundary';
import Slider from '../../hocs/Slider/Slider';
import SideMenu from '../SideMenu/SideMenu';
import Button from '../Parts/Button';
import { width, height, addEvent, removeEvent } from '../../utils/dom';
import s from './Product.scss';

class Product extends Component {
	static fetchData(props) {
		const { match, getProduct } = props;
		return getProduct(match.params.productUri);
	}

	static resizeEvent() {
		if (typeof window === 'undefined') return;
		const windowWidth = window.innerWidth;
		const windowHeight = window.innerHeight;
		const $productImages = document.getElementById('js-productImages');
		const $productInfo = document.getElementById('js-productInfo');

		if ($productImages === null || $productInfo === null) return;

		const imageRatio = $productImages.querySelector('img').dataset.width / $productImages.querySelector('img').dataset.height;
		const imageContainerRatio = width($productImages) / (windowHeight - 108);

		if (windowWidth > 1100 && imageContainerRatio > imageRatio) {
			const rightPos = (windowWidth - parseInt(window.getComputedStyle($productImages).marginLeft, 10) - ((windowHeight - 108) * imageRatio) - (width($productInfo) + 25)) / 2;
			$productInfo.style.right = `${rightPos}px`;
		} else {
			$productInfo.style = '';
		}
	}

	constructor(props) {
		super(props);

		window.scrollTo(0, 0);

		this.productDescription = React.createRef();

		this.state = {
			wholeDescription: false,
		};
	}

	componentDidMount() {
		Product.fetchData(this.props);

		addEvent(window, 'resize.infoCentering', () => {
			window.requestAnimationFrame(Product.resizeEvent);
		});

		Product.resizeEvent();
		this.props.updatePreviousPage(this.props.match.url);
	}

	shouldComponentUpdate({ products, match, getProduct }) {
		if (match.params.productUri && match.params.productUri !== this.props.match.params.productUri) window.scrollTo(0, 0);
		if (products[match.params.productUri] === undefined) {
			getProduct(match.params.productUri);
			return false;
		}
		return true;
	}

	componentDidUpdate(prevProps) {
		const { match, updatePreviousPage, previousPage } = this.props;
		if (prevProps.match.params.productUri && previousPage !== match.url) {
			window.scrollTo(0, 0);
			document.getElementById('js-productInfo').scrollTo(0, 0);
		}
		if (this.state.wholeDescription && previousPage !== match.url) {
			this.setState({ wholeDescription: false });
		}
		Product.resizeEvent();
		updatePreviousPage(match.url);
	}

	componentWillUnmount() {
		removeEvent(window, 'resize.infoCentering');
	}

	wholeDescriptionHandler(e) {
		e.preventDefault();

		this.setState({
			wholeDescription: !this.state.wholeDescription,
		});
	}

	render() {
		const { products, match } = this.props;
		const { wholeDescription } = this.state;
		if (this.props.setup.siteClosed === true) return <Redirect to="/" />;
		if (this.props.setup.siteClosed === undefined || products[match.params.productUri] === undefined) return null;

		const { navigation, toggleSideMenu, setup, addToBag, shop, toggleProductProperty, variables, filterProducts, productList } = this.props;
		const { product, openProperty, otherVariants } = products[match.params.productUri];
		const isAddedToBag = shop.checkout.items !== undefined && shop.checkout.items[product.ID] !== undefined;
		const productAvailability = productList.availability && productList.availability[parseInt(product.ID, 10)] !== undefined ? productList.availability[parseInt(product.ID, 10)].availability : true;
		const productToggle = {
			descriptionOpen: null,
			specificationOpen: null,
			shareOpen: null,
			productDescriptionOpen: null,
			otherVariantsStyle: null,
		};
		const descriptionParts = product.shortDescription.split(/<\/p>[^p]*<p>/);
		let buttonText = isAddedToBag ? setup.static.addOneMore : setup.static.addToBag;
		if (!productAvailability) buttonText = setup.static.soldOut;

		const imageArray = product.images.slice(1);
		imageArray.splice(2, 0, product.images.slice(0, 1)[0]);

		const productClasses = [s.product];
		if (navigation.sideMenuOpen) productClasses.push(s.product__mobileMenuOpen);

		if (openProperty) {
			productToggle[openProperty] = { height: `${height(document.getElementById(openProperty).querySelector('div')) + 45}px` };
		}

		const readMoreOpenStyle = wholeDescription ? { height: `${height(this.productDescription.current) + 45}px` } : {};

		if (variables.otherVariantsOpen) {
			productToggle.otherVariantsStyle = {
				height: `${(otherVariants.length * 22) + 27}px`,
			};
		}

		const addToBagHandler = (e) => {
			e.preventDefault();
			const $form = e.target.closest('form');
			const id = $form.dataset.id;
			addToBag(id, match.params.productUri);
		};

		const toggleHandler = (e) => {
			e.preventDefault();
			const $a = e.target.closest('a');
			const property = `${$a.getAttribute('href').slice(1)}Open`;
			toggleProductProperty(match.params.productUri, property);
			this.setState({
				wholeDescription: false,
			});
		};

		return (
			<main className={s.productPage} role="main">
				<Head>
					<title>{setup.meta && setup.meta.prefixTitle ? setup.meta.prefixTitle : ''} {product.name.replace('&amp;', '&')} {setup.meta && setup.meta.suffixTitle ? setup.meta.suffixTitle : ''}</title>
					<meta name="description" content={product.metaDescription} />
				</Head>
				<SideMenu navigation={navigation} toggleSideMenu={toggleSideMenu} staticTexts={setup.static} filterProducts={filterProducts} currentFilter="" />
				<div className={productClasses.join(' ')}>
					<ErrorBoundary message="Product images missing data" debugData={product}>
						<div id="js-productImages" className={s.product_images}>
							{
								imageArray.length > 0 ? (
									<Slider adaption="product" infinite location={match.params.productUri} screenMaxWidthDisable={1100} showArrows={false} interactionTypes={['click', 'rightClick']}>
										{
											imageArray.map(media => (
												media.src ? (
													<div key={media.src.slice(media.src.lastIndexOf('/') + 1)} className={s.product_images_media}>
														<img className={s.productImages_media_image} data-width={media.width} data-height={media.height} src={media.src} alt={media.alt ? media.alt : product.name.replace('&amp;', '&')} />
													</div>
												) : null
											))
										}
									</Slider>
								) : null
							}
						</div>
					</ErrorBoundary>
					<div id="js-productInfo" className={s.product_info}>
						<h1 className={s.product_info_title}>{product.name.replace('&amp;', '&')}</h1>
						<h3 className={s.product_info_shortSpecification}>{product.shortSpecification}<br />{product.weight}</h3>
						{ setup.shopClosed ? null : <h4 className={s.product_info_price}>[{product.price}]</h4> }
						<div className={[s.product_info_description, ...(wholeDescription ? [s.product_info_description__all] : [])].join(' ')}>
							<div className={s.product_info_description_top} dangerouslySetInnerHTML={{ __html: sanitize(`${descriptionParts[0]}</p>`) }} />
							<div className={s.product_info_description_bottom} style={readMoreOpenStyle}>
								<div ref={this.productDescription} dangerouslySetInnerHTML={{ __html: sanitize(`<p>${descriptionParts.slice(1).join('<p/><p>')}`) }} />
							</div>
							{ descriptionParts.length > 0 && !wholeDescription ? <a onClick={e => this.wholeDescriptionHandler(e)} className={s.product_info_description_readMore} href="#read-more">[{setup.static.readMore}]</a> : null }
						</div>
						{/* Display form only if item isn't sold out */}
						{
							!setup.shopClosed ? (
								<form className={s.product_info_purchase} action="" onSubmit={addToBagHandler} data-id={product.ID}>
									<Button text={buttonText} appearance={isAddedToBag ? 'button__inverted' : null} disabled={!productAvailability} />
								</form>
							) : null
						}
						<div id="descriptionOpen" className={s.product_info_section} style={productToggle.descriptionOpen}>
							<h5 className={(productToggle.descriptionOpen ? s.selected : '')}><a className={s.product_info_section_toggle} onClick={toggleHandler} href="#description"><span>{setup.static.description}</span></a></h5>
							<div className={s.product_info_section_content} dangerouslySetInnerHTML={{ __html: sanitize(product.description) }} />
						</div>
						<div id="specificationOpen" className={s.product_info_section} style={productToggle.specificationOpen}>
							<h5 className={(productToggle.specificationOpen ? s.selected : '')}><a className={s.product_info_section_toggle} onClick={toggleHandler} href="#specification"><span>{setup.static.specification}</span></a></h5>
							<div className={s.product_info_section_content} dangerouslySetInnerHTML={{ __html: sanitize(product.specification) }} />
						</div>
						<div id="shareOpen" className={s.product_info_section} style={productToggle.shareOpen}>
							<h5 className={(productToggle.shareOpen ? s.selected : '')}><a className={s.product_info_section_toggle} onClick={toggleHandler} href="#share"><span>{setup.static.share}</span></a></h5>
							<div className={s.product_info_section_content}>
								{ imageArray.length > 0 ? <a className={s.product_info_section_content_link} title="Pin it on Pinterest" rel="noopener noreferrer nofollow" target="_blank" href={`http://pinterest.com/pin/create/button/?url=${encodeURIComponent(window.location.href)}&amp;media=${encodeURIComponent(imageArray.src)}&amp;description=${encodeURIComponent(product.shareDescription)}`}>{setup.static.pinterest}</a> : null }
								<a className={s.product_info_section_content_link} href={`mailto:?subject=${encodeURIComponent(product.name.replace('&amp;', '&'))}&body=${encodeURIComponent(product.shareDescription)}%0A%0D${encodeURIComponent(window.location.href)}`}>{setup.static.email}</a>
								<a className={s.product_info_section_content_link} href={setup.static.instagramLink}>{setup.static.instagram}</a>
							</div>
						</div>
					</div>
				</div>
			</main>
		);
	}
}

export default Product;



// WEBPACK FOOTER //
// ./components/Product/Product.jsx